import { useImpactMode, type ImpactMode } from "../context/ImpactModeContext";

const OPTIONS: { value: ImpactMode; label: string; title: string }[] = [
    {
        value: "ctg",
        label: "Cradle to Grave",
        title: "Total lifecycle benefits vs fossil baseline — all phases",
    },
    {
        value: "ops",
        label: "Operations",
        title: "Operational displacement benefits only — excludes manufacturing",
    },
];

export function ImpactModeToggle() {
    const { mode, setMode } = useImpactMode();

    return (
        <div className="flex items-center bg-surface-600 rounded-md p-0.5">
            {OPTIONS.map((opt) => (
                <button
                    key={opt.value}
                    onClick={() => setMode(opt.value)}
                    title={opt.title}
                    className={`px-3 py-1 text-xs font-medium rounded transition-colors ${
                        mode === opt.value
                            ? "bg-surface-500 text-text-primary shadow-sm"
                            : "text-text-muted hover:text-text-secondary"
                    }`}
                >
                    {opt.label}
                </button>
            ))}
        </div>
    );
}
